import {gsap} from "gsap";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {TheCrypt} from "../../TheCrypt";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {TheCryptSymbolHighlighter} from "../../view/TheCryptSymbolHighlighter";
import {TheCryptSoundManager} from "../../sound/TheCryptSoundManager";


export class TheCryptXWayExpandPresentation implements SimplePresentation {
    name: string = "TheCryptXWayExpandPresentation";

    shouldRun(): boolean {
        return TheCrypt.model.hasXWaysSymbolThisAvalanche;
    }

    start(controller: SimplePresentationRunnerController): void {
        const tl: gsap.core.Timeline = gsap.timeline({onComplete: () => controller.finish()}),
        fast:boolean = (TheCrypt.apiPlugin.settings.get(APISetting.FAST_SPIN) || TheCrypt.model.hasNoAvalancheWin);
        tl.add(() => controller.setSkipCallback(() => {
            tl.timeScale(1.5);
        }));
        tl.add(TheCryptSymbolHighlighter.playXWayPotentialWinHighlighter());
        const expandStartPoint:number = tl.duration();
        if(fast){
            tl.add(()=>{TheCryptSoundManager.playSound(`xwaysExpand${TheCrypt.model.hasNoAvalancheWin ? "No" : ""}Win`)}, expandStartPoint);
        }
        TheCrypt.model.mysterySymbolPositions.forEach((reelId: number) => {
            let delay:number = fast?expandStartPoint:tl.duration();
            tl.add([
                ()=>{
                    if(!fast){
                        TheCryptSoundManager.playSound(`xwaysExpandWin`);
                    }
                },
                TheCrypt.realArea.allReels[reelId].reelView.expand()
            ], delay);
        });
        tl.to(this, {duration: 0.01});
    }
}